<template>
  <div class="selectedModels">
    <p class="text">
        当您选择某个车型组时，您选择的是与所列举车型相类似的车型。例如：当您选择预订“代步首选大众桑塔纳、大众捷达等同级别车型”时，表示您选择的是与大众桑塔纳、大众捷达相类似的代步首选车。需要注意的是，您在预订成功后，去门店取车时，取到的有可能是别克英朗，而不一定是大众桑塔纳或大众捷达。具体取到什么车型，要看您到门店取车时，您所预订的车型组相关车型的库存情况而定。
    </p>
  </div>
</template>

<script>
export default {
  name: "selectedModels"
}
</script>

<style scoped>
.selectedModels {
  font-size: 24px;
}
</style>

